export default __webpack_public_path__ + "static/bbti-e91a254091e8f614d21e6858257c21b6.jpg";